import { baseApi, getErrorMessage } from '@/shared/api';
import { mapDashboard } from '../libs/mapDashboard';
import type { Dashboard, Widget } from '../model/types';
import type { DashboardDTO } from './types';

export const getDashboards = async (): Promise<Dashboard[]> => {
  const { data, error } = await baseApi.functions.invoke<{
    dashboards: DashboardDTO[];
  }>('dashboards', { method: 'GET' });

  if (!data) {
    throw new Error(getErrorMessage(error));
  }

  return data.dashboards.map(mapDashboard);
};

export interface CreateDashboardParams {
  name: string;
  widgets: Widget[];
  favorite: boolean;
}

export const createDashboard = async (
  params: CreateDashboardParams,
): Promise<Dashboard> => {
  const { data, error } = await baseApi.functions.invoke<{
    dashboard: DashboardDTO;
  }>('dashboards', {
    method: 'POST',
    body: params,
  });

  if (!data) {
    throw new Error(getErrorMessage(error));
  }

  return mapDashboard(data.dashboard);
};

export interface UpdateDashboardParams {
  id: string;
  name?: string;
  widgets?: Widget[];
  favorite?: boolean;
}

export const updateDashboard = async (
  params: UpdateDashboardParams,
): Promise<Dashboard> => {
  const { id, ...body } = params;
  const { data, error } = await baseApi.functions.invoke<{
    dashboard: DashboardDTO;
  }>(`dashboards/${id}`, {
    method: 'PUT',
    body,
  });

  if (!data) {
    throw new Error(getErrorMessage(error));
  }

  return mapDashboard(data.dashboard);
};

export const deleteDashboard = async (id: string): Promise<void> => {
  const { error } = await baseApi.functions.invoke(`dashboards/${id}`, {
    method: 'DELETE',
  });

  if (error) {
    throw new Error(getErrorMessage(error));
  }
};
